var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSegment = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4 3a1 1 0 0 0-1 1v3h6v6h3a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 8H2v5a1 1 0 0 0 1 1h5V8z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSegment);
export default ForwardRef;